export const API_URL =  "https://dev-admin.talkspro.co/api/v1";
export const TOKEN_PREFIX = 'Bearer ';
export const VERSION_SESSION = '2';
export const TALKSPRO_URL =  "https://dev-hs-ws.talkspro.co/api/v1";
